import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { blogApi } from "../../api/endpoints";
import type { BlogPostCreate, BlogPostUpdate } from "@endeks/shared";

export function useBlogPosts(params?: { search?: string; published?: boolean }) {
  return useQuery({
    queryKey: ["blog", params],
    queryFn: () => blogApi.list(params).then((r) => r.data),
    // Aramada her tuşta iskelete düşmemek için önceki sonucu koru.
    placeholderData: keepPreviousData,
  });
}

export function useBlogPost(id: string) {
  return useQuery({
    queryKey: ["blog", id],
    queryFn: () => blogApi.get(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useCreateBlogPost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: BlogPostCreate) => blogApi.create(data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["blog"] }),
  });
}

export function useUpdateBlogPost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: BlogPostUpdate & { id: string }) =>
      blogApi.update(id, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["blog"] }),
  });
}

export function useDeleteBlogPost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => blogApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["blog"] }),
  });
}
